import api from '@/services/api'

export const getPdiAverage = async (userID, periods) => {
    try {
        return api.get(`users/${userID}/profile/pdis/average`, {
            params: {
                periods,
            },
        })
    } catch (e) {
        console.log(e)
    }
}
